import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/uni_modules/uni-datetime-picker/components/uni-datetime-picker/calendar.vue'
wx.createComponent(Component)